// extracted by mini-css-extract-plugin
export var addToCartButton = "_lv-b";
export var arrowButtonContainer = "_lv-9";
export var arrowButtonIcon = "_lv-a";
export var carouselArrowButton = "_lv-6";
export var carouselElementContainer = "_lv-1";
export var left = "_lv-7";
export var productDisplayCarouselContainer = "_lv-0";
export var productTileContainer = "_lv-2";
export var productTileImage = "_lv-4";
export var productTileImageContainer = "_lv-3";
export var productTileTitle = "_lv-5";
export var right = "_lv-8";
export var sliderOverflow = "_lv-c";